module.exports = __webpack_public_path__ + "img/bgDotted.656cb5ad.png";